<div class="progress-container" *ngIf="progressValue">
    <svg class="progress-ring" viewBox="0 0 120 120">
      <circle class="progress-ring-background" cx="60" cy="60" r="54"></circle>
      <circle class="progress-ring-fill" [style.stroke]="color" [attr.stroke-dasharray]="getStrokeDashArray()" [attr.stroke-dashoffset]="getStrokeDashOffset()" cx="60" cy="60" r="54"></circle>
      <text class="progress-text" x="50%" y="50%" text-anchor="middle" dy="8">{{ progressValue }}</text>
    </svg>
  </div>
  